import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { Router, Route, IndexRoute, hashHistory } from 'react-router';
import store from './store';

import App from './components/App/App';
import DashboardSwitcher from './components/DashboardSwitcher/DashboardSwitcher';
import Login from './components/Login/Login';

ReactDOM.render((
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={DashboardSwitcher} />
        <Route path="login" component={Login} />
      </Route>
    </Router>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js